import * as React from "react"
import {NumberFieldSeeker} from "@ui-seeker/core";

import {repricingFormErrors} from "../../../@signals";
import {useRepricingFormData} from "../../@hooks";


export default function RepricingFormRuleValue() {
	const { priceRuleValue, handleChangeValue } = useRepricingFormData()

    return <NumberFieldSeeker
		label="Percentage"
		endIcon="percent"
		error={repricingFormErrors.value.priceRuleValue}
		value={priceRuleValue}
		onChange={e => handleChangeValue('priceRuleValue', e.target.value)}
	/>
}